import { render, staticRenderFns } from "./IconNewChat.vue?vue&type=template&id=69f9cc06"
import script from "./IconNewChat.vue?vue&type=script&lang=js"
export * from "./IconNewChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports